import {Component, OnInit, ViewChild} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {NavigationService} from '../../../Services/navigation.service';
import { StorageService } from '../../../Services/storage.service';
import {DataService} from '../../../Services/data.service';
import { FilterPipe } from 'ngx-filter-pipe';
import { ConfirmDialogService } from '../../../Services/confirm-dialog.service';
import { BsToastService } from '../../../Services/bs-toast-service';
import {DecimalNewPipe} from '../../common/DecimalNewPipe';
import {EmailModel} from '../../../DataModels/email-model';

@Component({
  selector: 'app-statistical-form',
  templateUrl: './statistical-form.component.html',
  styleUrls: ['./statistical-form.component.css'],
  standalone: false
})
export class StatisticalFormComponent implements OnInit {
  vm: any = {};
  statisticalId;
  batchId;
  originalItem: any = {};
  originalSnapshot: any = null;
  showDelete;
  developerView;
  submitted = false;
  editNumber = false;
  accountInput: any = {};
  recurring = '';
  showImportButtons = false;
  private initCompleted = false;
  private accountsMapped = false;
  emailObject: EmailModel = new EmailModel();

  public urlParams: any = [];


  @ViewChild('csvReader', { static: false }) csvReader: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private titleService: Title,
    private confirmDialogService: ConfirmDialogService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalNewPipe,
    private nav: NavigationService,
  ) {
    this.vm.item = {};
    this.vm.item.header = {};
    this.vm.item.batch = {};
    this.vm.item.detail = {};
    this.vm.batch = {};
    this.vm.account = [];
    this.vm.location = [];
    // this.vm.currency = [];
    this.vm.company = [];
    this.vm.rfType = [];
    this.vm.accountFilter = {};
    this.vm.isLoaded = false;
    this.vm.companyIsLoaded = false;
    this.vm.locationIsLoaded = false;
    this.vm.currencyIsLoaded = false;
    this.vm.item.detail = [];
    this.vm.item.detail.id = [];
    this.vm.item.detail.accountInput = '';
    this.vm.item.header.description = '';
    this.vm.title = $localize`:Statistical Entry @@statisticalEntry:Statistical Entry`;
  }

  buttonConfig: any = {
    save: true,
    close: true,
    reset: false,
    delete: true,
    saveNew: false,
    saveClose: true,
    clone: true,
    email: true,
    print: true,
  };

  ngOnInit() {
    this.statisticalId = '';
    this.urlParams = this.route.snapshot.queryParams;
    this.statisticalId = this.urlParams.statisticalId;
    this.batchId = this.urlParams.batchId;
    this.recurring = this.urlParams.recurring;

    const isRecurring = this.recurring === 'true';
    const entryTitle = isRecurring
      ? $localize`:Recurring Statistical Entry @@recurringStatisticalEntry:Recurring Statistical Entry`
      : $localize`:Statistical Entry @@statisticalEntry:Statistical Entry`;
    this.vm.title = entryTitle;

    if (this.statisticalId === 'new') {
      this.vm.title = $localize`:New @@new:New` + ' ' + this.vm.title;
    } else {
      this.vm.title = $localize`:Edit @@edit:Edit` + ' ' + this.vm.title;
    }

    this.titleService.setTitle(this.vm.title);

    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences', ''));

    this.vm.alert = {};
    this.vm.alert.message = [];
    this.vm.newAccount = {};

    this.vm.item.header = {};
    this.vm.item.batch = {};
    this.vm.auditTrail = [];

    if (this.statisticalId === 'new') {
      const clonedItem = history.state?.clonedItem;
      this.vm.item = { batchTypeId: '16' };
      this.vm.auditTrail = [];
      this.vm.item.header = {};
      this.vm.item.batch = {};
      this.vm.item.batch.type_id = this.vm.item.batchTypeId;
      this.vm.item.detail = [];
      this.loadLookups();
      this.updateAccount();
      if (clonedItem) {
        this.vm.item = clonedItem;
        this.vm.item.header = this.vm.item.header || {};
        this.vm.item.batch = this.vm.item.batch || {};
        this.vm.item.detail = Array.isArray(this.vm.item.detail) ? this.vm.item.detail : [];
        this.vm.item.header.id = undefined;
        this.vm.item.header.number = undefined;
        this.vm.item.header.audit_sequence = undefined;
      } else {
        this.addRows(2);
        this.vm.item.header.header_date = this.datePipe.transform(new Date(), 'MM/dd/yyyy');
        this.vm.item.header.recurring = this.recurring == 'true';
      }
      this.vm.isLoaded = true;
      this.originalSnapshot = structuredClone(this.buildSnapshot());
    } else {
      this.getData();
    }
  }

  buildSnapshot(): any {
    return structuredClone(this.vm.item);
  }

  hasChanges(): boolean {
    if (!this.originalSnapshot) {
      return false;
    }

    return JSON.stringify(this.buildSnapshot()) !== JSON.stringify(this.originalSnapshot);
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }

  isFieldEmpty(value: any): boolean {
    let retVal = false;
    if (!value) {
      retVal = true;
    } else {
      retVal = false;
    }
    return retVal;
  }

  getData() {
    this.tableDataService.getData('entry', this.statisticalId).subscribe((result) => {
      this.vm.item = result;
      const entryTitle = this.vm.item?.header?.recurring
        ? $localize`:Recurring Statistical Entry @@recurringStatisticalEntry:Recurring Statistical Entry`
        : $localize`:Statistical Entry @@statisticalEntry:Statistical Entry`;
      this.vm.title = $localize`:Edit @@edit:Edit` + ' ' + entryTitle;
      this.titleService.setTitle(this.vm.title);
      this.getAccounts();
      this.loadLookups();
      // this.init();
      // this.createSignatureText();
      this.init().then((y) => {
        this.addTextSignature();
        this.initCompleted = true;
        if (this.accountsMapped) {
          this.originalSnapshot = structuredClone(this.buildSnapshot());
        }
      });
      this.updateAccount();
      this.formatDate();
      this.addRows(2);
      this.submitted = true;
    });
  }

  formatDate() {
    this.vm.item.header.header_date = this.datePipe.transform(this.vm.item.header.header_date, 'MM/dd/yyyy');
  }

  getAccounts() {
    this.tableDataService
      .getApiListData('account', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((value) => {
        const data: any = value.Data;
        this.vm.account = data.filter((x) => x.type_id === 7);

        for (const det of this.vm.item.detail) {
          // each detail record
          for (const acct of this.vm.account) {
            // each account
            if (det.account_id === acct.id) {
              const acctName = acct.number + ' ' + acct.name;
              det.accountInput = acctName;
            }
          }
        }
        this.accountsMapped = true;
        if (this.initCompleted) {
          this.originalSnapshot = structuredClone(this.buildSnapshot());
        }
      });
  }

  loadLookups() {
    this.tableDataService.getApiListData('uom', '?state=active&pageNumber=0&pageSize=999999').subscribe((value) => {
      this.vm.uom = value.Data;
    });

    this.tableDataService
      .getApiListData('account_subtotal_no_parents', '?pageNumber=0&pageSize=999999')
      .subscribe((value) => {
        this.vm.accountSubtotal = value.Data;
      });

    this.tableDataService.getApiListData('company', '?state=active&pageNumber=0&pageSize=999999').subscribe((value) => {
      this.vm.company = value.Data;
    });

    // this.tableDataService
    //   .getApiListData('currency', '?state=active&pageNumber=0&pageSize=999999')
    //   .subscribe((value) => {
    //     this.vm.currency = value.Data;
    //   });

    this.tableDataService
      .getApiListData('location', '?state=active&pageNumber=0&pageSize=999999')
      .subscribe((value) => {
        this.vm.location = value.Data;
      });

    this.tableDataService.getApiListData('reporting_field_type', '?pageNumber=0&pageSize=999999').subscribe((value) => {
      this.vm.rfType = value.Data;
    });

    this.tableDataService
      .getApiListData('reporting_field', '?type_id=rf1&state=active&pageNumber=0&pageSize=999999')
      .subscribe((value) => {
        this.vm.rf1 = value.Data;
      });

    this.tableDataService
      .getApiListData('reporting_field', '?type_id=rf2&state=active&pageNumber=0&pageSize=999999')
      .subscribe((value) => {
        this.vm.rf2 = value.Data;
      });

    this.tableDataService
      .getApiListData('reporting_field', '?type_id=rf3&state=active&pageNumber=0&pageSize=999999')
      .subscribe((value) => {
        this.vm.rf3 = value.Data;
      });

    this.tableDataService
      .getApiListData('reporting_field', '?type_id=rf4&state=active&pageNumber=0&pageSize=999999')
      .subscribe((value) => {
        this.vm.rf4 = value.Data;
      });

    this.tableDataService
      .getApiListData('reporting_field', '?type_id=rf5&state=active&pageNumber=0&pageSize=999999')
      .subscribe((value) => {
        this.vm.rf5 = value.Data;
      });
  }

  async init() {
    if (this.statisticalId === 'new') {
      // NEW ENTRY
      this.vm.item.header.currency_rate = '1';

      if (this.vm.Preferences.default_company_id) {
        this.vm.item.header.company_id = this.vm.Preferences.default_company_id;
      }
    } else {
      // EDIT ENTRY
      for (const obj of this.vm.item.detail) {
        if (obj.item_id) {
          if (this.FilterObject(this.vm.inventoryItem, { id: obj.item_id }, true)) {
            obj.itemInput = this.FilterObject(this.vm.inventoryItem, { id: obj.item_id }, true)[0].code;
          }
        }

        obj.amount = Number(obj.amount);
        obj.quantity = Number(obj.quantity);
        obj.debit_credit = Number(obj.debit_credit);
        if (obj.debit_credit > 0) {
          obj.amountInput = Number(obj.debit_credit);
          obj.dc = '1';
        } else {
          obj.amountInput = 0 - Number(obj.debit_credit);
          obj.dc = '-1';
        }
      }

      this.calcTotal();
      this.vm.isLoaded = true;
    }

    for (const obj of this.vm.item.detail) {
      if (obj.debit_credit) {
        obj.debit_credit = Number(obj.debit_credit);
      }
    }

    if (this.vm.company.length === 1) {
      this.vm.item.header.company_id = this.vm.company[0].id;
    }

    // if (this.vm.currency.length === 1) {
    //   this.vm.item.header.currency_id = this.vm.currency[0].id;
    // }
    if (this.vm.location.length === 1) {
      this.vm.item.header.location_id = this.vm.location[0].id;
    }
    this.createAccountName();

    // this.addRows(5); // create initial detail row
  }

  //  ACCOUNTS
  createAccountName() {
    this.vm.accountName = [];
    for (const obj of this.vm.account) {
      const tempName = obj.number + ' ' + obj.name;
      this.vm.accountName.push({
        name: tempName,
      });
    }
  }

  updateAccount() {
    this.vm.startAccount = 0;

    this.tableDataService.getApiListData('account', '?state=active&pageNumber=0&pageSize=999999').subscribe((value) => {
      // filter out all non stat accounts
      this.vm.account = value.Data.filter((x) => x.type_id === 7);
    });
  }

  selectAccountModal(accountId) {
    const id = this.vm.accountSelectDetailId;
    for (const obj of this.vm.item.detail) {
      if (obj.id == id) {
        for (const obj2 of this.vm.account) {
          if (obj2.id == accountId) {
            obj.account_id = obj2.id;
            obj.accountInput = obj2.number + ' ' + obj2.name;
            break;
          }
        }
        break;
      }
    }
  }

  accountSelected(id) {
    for (const obj of this.vm.item.detail) {
      if (obj.id == id) {
        // obj.account_id = '';
        if (obj.accountInput !== undefined && obj.accountInput.length > 0) {
          let found = false;
          for (const obj2 of this.vm.account) {
            if (obj2.number + ' ' + obj2.name == obj.accountInput) {
              obj.account_id = obj2.id;
              found = true;
              break;
            }
          }
          if (!found) {
            this.notification.showWarningToast($localize`:Account not found @@accountnotfound:Account not found`);
            obj.accountInput = '';
            obj.account_id = undefined;
          }
        } else {
          obj.account_id = undefined;
        }
        break;
      }
    }
  }

  saveNewAccount() {
    let errorDescription = '';
    this.vm.accountButtonsDisabled = true;

    if (!this.vm.newAccount.name) {
      errorDescription += $localize`:Name is required. @@nameisrequired:Name is required.` + '<br/>';
      this.vm.newAccountNameError = true;
    } else if (this.FilterObject(this.vm.account, { name: this.vm.newAccount.name }, true).length > 0) {
      if (
        this.FilterObject(this.vm.account, { name: this.vm.newAccount.name }, true)[0].name == this.vm.newAccount.name
      ) {
        this.vm.newAccountNameError = true;
        errorDescription += $localize`:Name is a duplicate. @@nameisaduplicate:Name is a duplicate.` + '<br/>';
      }
    }
    if (!this.vm.newAccount.number) {
      errorDescription += $localize`:Number is required. @@numberisrequired:Number is required.` + '<br/>';
      this.vm.newAccountNumberError = true;
    } else if (this.FilterObject(this.vm.account, { name: this.vm.newAccount.number }, true).length > 0) {
      if (
        this.FilterObject(this.vm.account, { name: this.vm.newAccount.number }, true)[0].number ==
        this.vm.newAccount.number
      ) {
        this.vm.newAccountNumberError = true;
        errorDescription += $localize`:Number is a duplicate. @@numberisaduplicate:Number is a duplicate.` + '<br/>';
      }
    }

    if (errorDescription === '') {
      this.tableDataService.post('account', this.vm.newAccount).subscribe(
        (item: any) => {
          // this.notification.success(item.description);
          this.vm.accountButtonsDisabled = false;
          this.updateAccount();
          this.vm.newAccount = {};
        },
        (error: { error: { Message: string }; statusText: string }) => {
          this.vm.accountButtonsDisabled = false;
          let ErrorMsg: string;
          if (typeof error.error.Message != 'undefined') {
            ErrorMsg = error.error.Message;
          } else {
            ErrorMsg = error.statusText;
          }
        }
      );
    } else {
      // report error
      this.vm.accountButtonsDisabled = false;
    }
  }

  // UTILITIES

  addRows(qty) {
    if (qty == '') {
      qty = 0;
    }
    let maxSortOrder = 0;
    for (const obj of this.vm.item.detail) {
      if (maxSortOrder < obj.sort_order) {
        maxSortOrder = obj.sort_order;
      }
    }
    for (let x = 1; x <= qty; x++) {
      // tempID = this.vm.item.detail.length + 1;
      const tempDate = new Date();
      const tempID =
        tempDate.getMinutes() * (tempDate.getSeconds() + tempDate.getMilliseconds()) + this.vm.item.detail.length;
      maxSortOrder++;
      this.vm.item.detail.push({
        id: tempID,
        quantity: 0,
        sort_order: maxSortOrder,
      });
    }
  }

  deleteLine(id) {
    for (let x = 0; x < this.vm.item.detail.length; x++) {
      if (this.vm.item.detail[x].id == id) {
        this.vm.item.detail.splice(x, 1);
        this.calcTotal();
      }
    }
  }

  calcTotal() {
    let total = 0;
    for (const obj of this.vm.item.detail) {
      obj.debit_credit = 0;
      if (obj.amountInput && obj.dc) {
        obj.debit_credit = obj.amountInput * obj.dc;
        if (!Number(obj.debit_credit) && obj.debit_credit != '-') {
          this.notification.showWarningToast('Debit or Credit is not a number, please remove any text.');
        } else if (obj.debit_credit != '-') {
          total += Number(obj.debit_credit);
        }
      }
    }
    this.vm.total = Math.round(total * 100) / 100;
  }

  print() {
    const html = this.buildStatisticalPrintHtml();
    this.printHtmlInIframe(html);
  }

  onPrint() {
    try {
      this.print();
    } catch (e) {
      console.error('Print failed', e);
      this.notification.showErrorToast('Unable to print this statistical entry');
    }
  }

  onEmail() {
    const header = this.vm?.item?.header || {};
    if (!header?.id) {
      this.notification.showWarningToast('Please save the statistical entry before emailing');
      return;
    }

    const html = this.buildStatisticalPrintHtml();
    const companyName = this.getCompanyNameById(header.company_id);
    const entryNumber = header.audit_sequence || header.number || header.id;
    const entryLabel = header?.recurring ? 'Recurring Statistical Entry' : 'Statistical Entry';

    this.emailObject = new EmailModel();
    this.emailObject.Subject = `${companyName ? companyName + ' - ' : ''}${entryLabel} ${entryNumber}`;
    this.emailObject.header_id = header.id;
    this.emailObject.batch_type_id = String(this.vm?.item?.batch?.type_id || '16');
    this.emailObject.FileName = `StatisticalEntry-${entryNumber}`;
    this.emailObject.convert_attachment_to = 'pdf';
    this.emailObject.print_orientation = 'landscape';
    this.emailObject.pdfHtml = html;
    this.emailObject.body = `Please see the attached ${entryLabel} ${entryNumber}.<br><br><br>Best regards,<br><br>AcctXErp<br><br>`;
    this.emailObject.includeAttachment = true;
  }

  async onClone() {
    try {
      const cloned = structuredClone(this.vm?.item || {});
      cloned.header = cloned.header || {};
      cloned.detail = Array.isArray(cloned.detail) ? cloned.detail : [];
      cloned.header.id = undefined;
      cloned.header.number = undefined;
      cloned.header.audit_sequence = undefined;

      await this.router.navigate(['/transactions/statistical/form'], {
        queryParams: {statisticalId: 'new'},
        state: {clonedItem: cloned}
      });
    } catch {
      await this.router.navigateByUrl('/transactions/statistical/form?statisticalId=new');
    }
  }

  private getCompanyNameById(id: any): string {
    const list = Array.isArray(this.vm?.company) ? this.vm.company : [];
    const found = list.find((c: any) => String(c?.id) === String(id));
    return found?.name || '';
  }

  private buildStatisticalPrintHtml(): string {
    const item = this.vm?.item || {};
    const header = item?.header || {};
    const details: any[] = Array.isArray(item?.detail) ? item.detail : [];
    const companyName = this.getCompanyNameById(header.company_id);
    const entryNumber = header.audit_sequence || header.number || header.id || '';
    const entryLabel = header?.recurring ? 'Recurring Statistical Entry' : 'Statistical Entry';
    const date = header.header_date ? new Date(header.header_date) : new Date();
    const dateStr = date.toLocaleDateString();

    const getAccountDisplay = (d: any): string => {
      const input = String(d?.accountInput ?? '').trim();
      if (input) {
        return input;
      }

      const id = String(d?.account_id ?? '').trim();
      if (!id) {
        return '';
      }

      const account = (Array.isArray(this.vm?.account) ? this.vm.account : []).find((a: any) => String(a?.id) === id);
      if (!account) {
        return '';
      }

      return `${account?.number ?? ''} ${account?.name ?? ''}`.trim();
    };

    const getAccountNumber = (d: any): string => {
      const fromDetail = String(d?.account_number ?? '').trim();
      if (fromDetail) {
        return fromDetail;
      }

      const display = getAccountDisplay(d);
      if (!display) {
        return '';
      }

      const firstSpace = display.indexOf(' ');
      return firstSpace > 0 ? display.slice(0, firstSpace).trim() : display;
    };

    const getAccountName = (d: any): string => {
      const fromDetail = String(d?.account_name ?? '').trim();
      if (fromDetail) {
        return fromDetail;
      }

      const display = getAccountDisplay(d);
      if (!display) {
        return '';
      }

      const firstSpace = display.indexOf(' ');
      return firstSpace > 0 ? display.slice(firstSpace + 1).trim() : '';
    };

    const getUomName = (d: any): string => {
      const fromDetail = String(d?.uom_name ?? '').trim();
      if (fromDetail) {
        return fromDetail;
      }

      const id = String(d?.uom_id ?? '').trim();
      if (!id) {
        return '';
      }

      const uom = (Array.isArray(this.vm?.uom) ? this.vm.uom : []).find((u: any) => String(u?.id) === id);
      return String(uom?.name ?? '').trim();
    };

    const rows = details
      .map((d: any) => `
      <tr>
        <td>${getAccountNumber(d)}</td>
        <td>${getAccountName(d)}</td>
        <td>${getUomName(d)}</td>
        <td style="text-align:right;">${d?.debit_credit ?? ''}</td>
      </tr>`)
      .join('');

    return `
<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>${entryLabel} ${entryNumber}</title>
  <style>
    body { font-family: Arial, sans-serif; color: #222; margin: 24px; }
    h2 { margin: 0 0 10px 0; }
    .meta { margin-bottom: 16px; }
    .meta div { margin: 2px 0; }
    table { width: 100%; border-collapse: collapse; }
    th, td { border: 1px solid #ddd; padding: 8px; font-size: 12px; }
    th { background: #f7f7f7; text-align: left; }
  </style>
</head>
<body>
  <h2>${entryLabel}</h2>
  <div class="meta">
    <div><strong>Company:</strong> ${companyName}</div>
    <div><strong>Number:</strong> ${entryNumber}</div>
    <div><strong>Date:</strong> ${dateStr}</div>
    <div><strong>Description:</strong> ${header?.description || ''}</div>
    <div><strong>Comments:</strong> ${header?.comment || ''}</div>
  </div>
  <table>
    <thead>
      <tr>
        <th>Account #</th>
        <th>Account</th>
        <th>UOM</th>
        <th>Quantity</th>
      </tr>
    </thead>
    <tbody>
      ${rows}
    </tbody>
  </table>
</body>
</html>`;
  }

  private printHtmlInIframe(html: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.setAttribute('aria-hidden', 'true');

    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) {
      this.notification.showErrorToast('Unable to access print frame');
      document.body.removeChild(iframe);
      return;
    }

    doc.open();
    doc.write(html);
    doc.close();

    const printAndCleanup = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      } finally {
        setTimeout(() => {
          if (iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
        }, 1000);
      }
    };

    if (doc.readyState === 'complete') {
      setTimeout(printAndCleanup, 250);
    } else {
      iframe.onload = () => setTimeout(printAndCleanup, 250);
    }
  }

  saveClose() {
    this.save();
    this.onClose();
  }

  save() {
    this.submitted = true;
    this.vm.errorDescription = '';

    // check errors

    if (!this.vm.item.header.header_date) {
      this.vm.errorDescription += $localize`:Date is required. @@dateisrequired:Date is required.` + '<br/>';
      this.vm.dateMissing = true;
    } else {
      const yearEndDate = this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0]
        .year_end_date;
      const cutOffDate = this.FilterObject(this.vm.company, { id: this.vm.item.header.company_id }, true)[0]
        .cut_off_date;
      const tempYearEndDate = new Date(yearEndDate);
      const tempCutOffDate = new Date(cutOffDate);
      const headerDate = new Date(this.vm.item.header.header_date);
      if (headerDate < tempYearEndDate) {
        this.vm.errorDescription +=
          $localize`:Date must be greater than the the year end @@datemustbegreaterthanthetheyearend:Date must be greater than the the year end` +
          ' ' +
          yearEndDate +
          '<br/>';
      }
      if (headerDate < tempCutOffDate) {
        this.vm.errorDescription +=
          $localize`:Date must be greater than the cut off date @@datemustbegreaterthanthecutoffdate:Date must be greater than the cut off date` +
          ' ' +
          cutOffDate +
          '<br/>';
      }
    }

    if (!this.vm.item.header.company_id) {
      this.vm.errorDescription += $localize`:Company is required. @@companyisrequired:Company is required.` + '<br/>';
      this.vm.companyError = true;
    }
    if (!this.vm.item.header.location_id) {
      this.vm.errorDescription +=
        $localize`:Location is required. @@locationisrequired:Location is required.` + '<br/>';
      this.vm.locationError = true;
    }
    // no currency on statiscal - quantity of uom only
    // if (!this.vm.item.header.currency_id) {
    //   this.vm.errorDescription +=
    //     $localize`:Currency is required. @@currencyisrequired:Currency is required.` + '<br/>';
    //   this.vm.currencyError = true;
    // }

    if (!this.vm.item.header.description) {
      this.vm.errorDescription +=
        $localize`:Description is required. @@descriptionisrequired:Description is required.` + '<br/>';
      this.vm.descriptionError = true;
    }

    if (this.vm.item.detail !== undefined) {
      let rowsFound = false;
      for (const obj of this.vm.item.detail) {
        if (
          obj.account_id !== undefined &&
          obj.uom_id !== undefined &&
          obj.debit_credit !== undefined &&
          obj.accountInput !== undefined
        ) {
          rowsFound = true;
        }
      }
      if (!rowsFound) {
        this.vm.errorDescription += $localize`:No Entry rows found. @@noentryrowsfound:No Entry rows found.` + '<br/>';
        this.vm.descriptionError = true;
      }
    }

    if (this.vm.item.detail !== undefined) {
      for (const obj of this.vm.item.detail) {
        if (
          obj.account_id !== undefined &&
          obj.uom_id !== undefined &&
          (obj.debit_credit === undefined || obj.debit_credit === '')
        ) {
          // console.log('dr: ' + obj.debit_credit);
          this.vm.errorDescription += $localize`:Missing Quantity. @@missingquantity:Missing Quantity.` + '<br/>';
          this.vm.descriptionError = true;
        }
      }
    }

    if (this.vm.item.detail !== undefined) {
      for (const obj of this.vm.item.detail) {
        if (obj.account_id !== undefined && (obj.uom_id === undefined || obj.uom_id === '' || obj.uom_id === null)) {
          this.vm.errorDescription += $localize`:Missing UOM. @@missinguom:Missing UOM.` + '<br/>';
          this.vm.descriptionError = true;
        }
      }
    }

    // report error
    if (this.vm.errorDescription !== '') {
      this.vm.buttonsDisabled = false;
      const arr = this.vm.errorDescription.split('<br/>');
      arr.forEach((item) => {
        if (item) {
          this.notification.showWarningToast(item);
        }
      });
      return; // stop post / patch and go back so user can fix since there are errors
    } else {
      this.vm.buttonsDisabled = true;

      if (this.vm.item.header.id === undefined) {
        // new
        this.tableDataService.post('entry', this.vm.item).subscribe(
          (item: any) => {
            this.vm.buttonsDisabled = false;
            // this.notification.showSuccessToast(item.id);
            this.originalSnapshot = structuredClone(this.buildSnapshot());
            this.router.navigateByUrl('/transactions/statistical/form?statisticalId=' + item.id).then();
          },
          (error: { error: { Message: string }; statusText: string }) => {
            this.vm.buttonsDisabled = false;
            let ErrorMsg: string;
            if (typeof error.error.Message != 'undefined') {
              ErrorMsg = error.error.Message;
            } else {
              ErrorMsg = error.statusText;
            }
          }
        );
      } else {
        // edit

        this.tableDataService
          .patch('entry', this.vm.item.header.id, this.vm.item)
          .then((item: any) => {
            if (item) {
              // this.notification.info(item.description);
            }
            this.vm.buttonsDisabled = false;
            this.originalSnapshot = structuredClone(this.buildSnapshot());
            if (item.description == 'Deleted') {
              this.router.navigate(['/transactions/statistical/list/']).then();
            }
          })
          .catch((msg: string) => {
            this.vm.buttonsDisabled = false;
          });
      }
    }
  }

  uploadListener(event): void {
    const result = [];
    const files = event.srcElement.files;

    if (this.isValidCSVFile(files[0])) {
      const input = event.target;
      const reader = new FileReader();
      let headers = [];
      reader.readAsText(input.files[0]);

      reader.onload = () => {
        const csvData = reader.result;
        const rows = (csvData as string).split(/\r\n|\n/);
        for (let i = 0; i < rows.length; i++) {
          if (i == 0) {
            headers = rows[i].split(',');
            for (let j = 0; j < headers.length; j++) {
              headers[j] = headers[j].toLowerCase();
              headers[j] = headers[j].replace('\r', '');
              headers[j] = headers[j].trimEnd();
            }
          } else {
            const obj = {};
            const cells = rows[i].split(',');
            for (let j = 0; j < cells.length; j++) {
              cells[j] = cells[j].replace('\r', '');
              //  if (headers[j] === 'debit' || headers[j] === 'credit') {
              //      cells[j] = Number(cells[j]);
              //  }
              obj[headers[j]] = cells[j];
            }
            result.push(obj);
          }
        }
        if (result) {
          this.vm.csvResults = result;
          // document.getElementById('upload-buttons').classList.remove('d-none');
          this.showImportButtons = true;
          this.notification.showSuccessToast('Entries Imported For Review');
        }
      };
      reader.onerror = () => {
        this.notification.showErrorToast(
          $localize`:error is occured while reading file! @@errorisoccuredwhilereadingfile:error is occured while reading file!`
        );
      };
    } else {
      this.notification.showErrorToast(
        $localize`:Please import valid .csv file. @@pleaseimportvalidcsvfile:Please import valid .csv file.`
      );
      this.csvReader.nativeElement.value = '';
      this.vm.csvResults = {};
    }
  }

  isValidCSVFile(file: any) {
    return file.name.endsWith('.csv');
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  onClose() {
    const fallback = this.vm?.item?.header?.recurring
      ? '/transactions/statistical/recurring-list'
      : '/transactions/statistical/list';
    // Call the shared navigation service directly; avoid nullish coalescing on a void-returning call
    // which leads to TS1345. The service is provided in root and injected, so it will be defined.
    this.nav.backOr(fallback);
  }

  signature(signature) {
    // this.vm.linkedSignature = signature;
    this.vm.item.header.signature = signature;
    this.vm.getSignature = true;
    document.getElementById('closeSignatureModel').click();
    this.save();
  }

  deleteSignature() {
    this.vm.item.header.signature = '';
    this.vm.getSignature = true;
    document.getElementById('closeSignatureModel').click();
    this.save();
  }

  addTextSignature() {
    let text;
    text = 'Entry ';
    text += 'Number: ' + this.vm.item.header.audit_sequence + '      ';
    text += 'Total: $' + this.decimalPipe.transform(this.vm.total);
    this.vm.addTextSignature = text;
  }
  gotAnUploadFile(file: any) {
    // console.log('in got a file: ' + file);
    // console.log('in got a file: ');
  }

  syncItemAttachments(attachmentsArray: any) {
    // console.log('attachments array recvd in main');
    // console.log(attachmentsArray);

    // clear existing - will be put back because in array passed back in file upload array
    this.vm.item.attachments = [];

    // use the pieces needed for the api record
    attachmentsArray.forEach((x) => {
      this.vm.item.attachments.push({
        id: x.id,
        header_id: x.header_id,
        file_name: x.fileName,
        type: x.fileType,
        attachment: x.fileData,
        audit_sequence: 0
      });
    });
    // console.log('main vm array after sync to file upload data');
    // console.log(this.vm);
  }

  deleteItem() {
    if (this.statisticalId != 'new') {
      const brClass = this;
      // let retMsg = '';
      const messages: string[] = [
        $localize`:Are you sure you want to delete record? @@areyousureyouwanttodeleterecord:Are you sure you want to delete record?`,
        '',
      ];
      this.confirmDialogService.confirmThis(
        messages,
        () => {
          this.vm.item.header.deleted = true;
          this.save();
        },
        () => {
          brClass.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
        }
      );
    }
  }

  protected readonly window = window;
}
